import type { PatternFormFieldItem } from '@ricoh/ria.client.core/types/component/pattern.type';
import type { RecordKey } from '@ricoh/ria.client.core/types/core/data.type';

import type { PatternParameter } from '~/common/model/api/batch-type/pattern';

/** Create Pattern Parameter. */
export const createPatternParameter = {
  parameter: (value: string): PatternParameter => ({
    $is: 'parameter',
    name: value,
  }),
};

/** Create Pattern Parameter FormField. */
export const createPatternParameterFormField = {
  parameter: <TTabKey extends RecordKey>(tabKey: TTabKey, pattern: PatternParameter): PatternFormFieldItem<TTabKey> => ({
    $is: 'tag',
    tabKey,
    value: pattern.name,
  }),
};
